// QuickPatientModal.js - Snabbmodal för att skapa ny patient från sidebaren
// (och startsidan). Formuläret är det gemensamma NewPatientForm.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import NewPatientModal from '../common/NewPatientModal';

const QuickPatientModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  // Ny eller befintlig patient → öppna patienten
  const openPatient = (patient) => {
    onClose();
    navigate(`/patients/${patient.patient_id}`);
  };

  return (
    <NewPatientModal
      isOpen={isOpen}
      onClose={onClose}
      onCreated={openPatient}
      onExisting={openPatient}
    />
  );
};

export default QuickPatientModal;
